/**
 * Razorpay Checkout helper — loads the Checkout JS script once and exposes
 * a single `openCheckout(options)` function.
 */

let _scriptPromise = null;

function loadScript() {
  if (_scriptPromise) return _scriptPromise;
  _scriptPromise = new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve();
      return;
    }
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Razorpay Checkout failed to load"));
    document.body.appendChild(s);
  });
  return _scriptPromise;
}

/**
 * Open Razorpay Checkout.
 * @param {object} options Standard Razorpay options. Required:
 *   key, amount, currency, order_id, name, description, prefill, handler, theme
 * @returns {Promise<void>} Resolves once the modal is opened (not when paid).
 */
export async function openCheckout(options) {
  await loadScript();
  // eslint-disable-next-line no-undef
  const rzp = new window.Razorpay(options);
  rzp.on("payment.failed", (response) => {
    if (typeof options.onFailed === "function") options.onFailed(response);
  });
  rzp.open();
}
